import { render, staticRenderFns } from "./LimitlessPageFooter.vue?vue&type=template&id=25864626&"
import script from "./LimitlessPageFooter.vue?vue&type=script&lang=js&"
export * from "./LimitlessPageFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports